// extracted by mini-css-extract-plugin
export default {"page_header":"PageHeader_page_header__gpPcE","web_title":"PageHeader_web_title__nAvOy","user_info":"PageHeader_user_info__8-zGf"};